import { render } from "./PublicTrackingOrder.vue?vue&type=template&id=66bd46a6&ts=true"
import script from "./PublicTrackingOrder.vue?vue&type=script&lang=ts"
export * from "./PublicTrackingOrder.vue?vue&type=script&lang=ts"

import "./PublicTrackingOrder.vue?vue&type=style&index=0&id=66bd46a6&lang=css"

import exportComponent from "/home/starkoms/webapps/front-comm-starkoms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__